( function ( _s ) {
	/**
	 * Using the library serbanghita/form-to-object we create an object off the inputs of the form
	 * We also make it so that if any value on the object is an array we convert the values to comma
	 * separated values so that the URLs look shorter and the parameters on the AJAX calls are shorter
	 * to read too.
	 * @param _form
	 */
	const serializeFormData = _form => {
		const form = _form instanceof Element ? _form : _form.el[ 0 ];
		const data = formToObject( form, {
			includeEmptyValuedElements: true,
		} );

		for ( const [ key, value ] of Object.entries( data ) ) {
			if ( Array.isArray( data[ key ] ) ) {
				data[ key ] = value.filter( n => n ).join( ',' ); //filter empty options just in case and comma separate
			}
		}
		return data;
	};

	const onFiltersChanged = ( _self, filterTarget = false ) => {
		_self.trigger( 'fr:filters-changed', {
			params: { ...serializeFormData( _self ), ...{ page: 1 } }, //change page number when filter changed,
			target: filterTarget,
		} );
	};

	const toggleShowFieldsetsForPostTypes = ( _self, field ) => {
		const _fieldsets = _self.find( '[fieldset-for-post-types]' );
		const _shownFilters = _fieldsets.filter( ( i, iEl ) => {
			const fieldsetPostTypes = _s( iEl ).attr( 'fieldset-for-post-types' ).split( ';' );
			const selectedPostTypes = field.value.split( ',' );
			const intersection = fieldsetPostTypes.filter( val =>
				selectedPostTypes.includes( val )
			);

			return intersection.length === selectedPostTypes.length;
		} );

		//hide all & disable all inputs inside
		_fieldsets
			.addClass( 'd-none' )
			.find( `select, textarea, input[type]` )
			.each( iEl => ( iEl.disabled = 'disabled' ) );

		//show the correct ones
		_shownFilters
			.removeClass( 'd-none' )
			.find( `select, textarea, input[type]` )
			.each( iEl => ( iEl.disabled = false ) );
	};

	_s.fn.cardGridFilters = function () {
		return this.each( el => {
			const _self = _s( el );

			_self.find( `select, textarea, input[type]` ).on( 'change', e => {
				if (
					! e.currentTarget.disabled &&
					e.currentTarget.getAttribute( 'type' ) !== 'hidden'
				) {
					//lets hide/show conditional fieldsets tied to the post_type radio option first
					if ( e.currentTarget.getAttribute( 'name' ) === 'p_type' )
						toggleShowFieldsetsForPostTypes( _self, e.currentTarget );

					onFiltersChanged( _self, e.target );
				}
			} );

			_self.on( 'fr:get-filters-config', e => {
				if ( e.detail.callback ) e.detail.callback( serializeFormData( _self ) );
			} );

			_self.on( 'submit', e => {
				e.preventDefault();
				onFiltersChanged( _self );
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.card-grid-filters' ).cardGridFilters();
	} );
} )( window._s );
